<script setup lang="ts">
import { ref, onMounted } from 'vue'

import { useFormStore } from '@/stores/form'
const formStore = useFormStore()

import { useUserStore } from '@/stores/user'
const userStore = useUserStore()

const userList = ref([])

function gowork() {
  formStore.switchForm('video')
}

function gotoTrf  () {
  formStore.switchForm('transfer')  
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd}`;
}

const openInNewTab = () => {
  window.open(`https://video.qianchih.net/`, '_blank')
  gotoTrf()  
}

onMounted(async () => {
  userList.value = await userStore.getaccountbycompanyNo(userStore.account)
})
</script>

<template>
  <div class="page-container">
    <table class="centered-table">
      <thead>
        <tr>
          <th>帳號</th>
          <th>到期日</th>
          <th>付款方式</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in userList" :key="index">
          <td>{{ user.fAccount }}</td>
          <td>{{ formatDate(user.fEndDate) }}</td>
          <td>{{ user.fPayway }}</td>
        </tr>
      </tbody>    
    </table>

    <!-- 按鈕區塊 -->        
      <button @click="gowork">返回</button>
    
  </div>
</template>


<style scoped>
.page-container {
  background-color: black;
  border-radius: 10px;
  padding: 2rem;
  min-height: 100vh;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.centered-table {
  border-collapse: collapse;
  margin: 2rem 0;
  color: white;
}

.centered-table th,
.centered-table td {
  border: 1px solid deeppink;
  padding: 0.5rem 1rem;
  text-align: left;
}

.centered-table th {
  background-color: black;
}
button {
  margin: 15px 0;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 20px;
  background-color: deeppink;
  width: 400px;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  align-self: center;
}
button:hover {
  transform: scale(1.04);
}
</style>
